import { Component, OnDestroy, OnInit, ViewChild, HostListener, ElementRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalEmploymentHistoryComponet } from 'app/views/modales/recruitment/employment-history/modal-employment-history.component';
import { ModalLanguageComponet } from 'app/views/modales/recruitment/language/modal-language.component';
import { ModalReferenceComponet } from 'app/views/modales/recruitment/reference/modal-reference.component';
import { ModalStudyComponet } from 'app/views/modales/recruitment/study/modal-study.component';
import { RecruitmentService } from '../recruitment.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IGeneralData } from 'app/shared/models/recruitment/general-data.model';
import { Observable } from 'rxjs';
import { IResult } from 'app/shared/models/result.model';
import { AppConfig } from 'app/app.config';
import { ModalAppearanceComponet } from 'app/views/modales/recruitment/appearance/modal-appearance.component';
import { MatRadioChange } from '@angular/material';
import { ISelect } from 'app/shared/models/select.model';
import { ValidatorService } from 'app/shared/services/validator.service';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { IAppearance } from 'app/shared/models/recruitment/appearance.model';
import { IStudy } from 'app/shared/models/recruitment/study.model';
import { IEmploymentHistory } from 'app/shared/models/recruitment/employment-history.model';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { IRecruiterComment } from 'app/shared/models/recruitment/recruiter-comment.model';
import { ISkillItem } from 'app/shared/models/recruitment/skill-item.model';
import { ITrademarkItem } from 'app/shared/models/recruitment/trademark-item.model';
import { IDocument } from 'app/shared/models/recruitment/document.model';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { OpeningService } from '../../opening/opening.service';
import { saveAs } from 'file-saver';
import { SecurityService } from 'app/shared/services/security.service';
import { DialogService } from '../../../../shared/services/dialog.service';
import { IEmploymentHistoryItem } from 'app/shared/models/recruitment/employment-history-item.model';
import { ModalEmploymentHistoryCommentsComponent } from 'app/views/modales/recruitment/employment-history/modal-employment-history-comments.component';
import { CustomerService } from '../../quote/customer.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from '../../security/identity.service';
@Component({
  selector: 'app-request',
  styleUrls: ['./request.style.scss'],
  templateUrl: 'request.template.html'
})
export class RequestComponent implements OnDestroy, OnInit {

  @HostListener('window:beforeunload', ['$event'])
  doSomething($event) {
    if (this.formGeneralData.dirty || this.formDocuments.dirty || this.formEmploymentHistory.dirty
      || this.formRecruiterComments.dirty || this.formStudy.dirty)
      $event.returnValue = '';
  }
  canDeactivate(): Observable<boolean> | boolean {
    if (this.formGeneralData.dirty || this.formDocuments.dirty || this.formEmploymentHistory.dirty
      || this.formRecruiterComments.dirty || this.formStudy.dirty) {
      const confirmation = window.confirm('No se han guardado los cambios ¿Desea continuar?');
      return Observable.of(confirmation);
    }
    return true;
  }

  /**Validadores */
  private validator = ValidatorService;
  private fsaFlags = [false];
  private flag = false;
  private errorMessages: any;
  /**Modales */
  private modalRef: BsModalRef;
  private configModal = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
  };
  /**Formularios */
  private formGeneralData: FormGroup;
  private formPhysicalComplexion: FormGroup;
  private formEmploymentHistory: FormGroup;
  private formStudy: FormGroup;
  private formRecruiterComments: FormGroup;
  private formDocuments: FormGroup;
  @ViewChild('addSwal', { static: false }) private addSwal: SwalComponent;
  @ViewChild('deleteSwal', { static: false }) private deleteSwal: SwalComponent;
  @ViewChild('selectRecruiter', { static: false }) private selectRecruiter: ElementRef;
  /**Catalogos */
  private catalogGenders: ISelect[];
  private catalogZones: ISelect[];
  private catalogMaritalStatus: ISelect[];
  private catalogSources: ISelect[];
  private catalogSizes: ISelect[];
  private catalogShirtSizes: ISelect[];
  private catalogPhoneCompanies: Observable<ISelect[]>;
  private catalogPhonePlans: Observable<ISelect[]>;
  private catalogGenderSizes: ISelect[];
  private catalogStates: ISelect[];
  private catalogStateBirth: ISelect[];
  private catalogCountries: ISelect[];
  private catalogPhysicalComplexion: ISelect[];
  private catalogSchoolLevels: ISelect[];
  private catalogStatures: ISelect[];
  private catalogShoeSizes: ISelect[];
  private catalogPositions: ISelect[];
  private catalogRequisitions: ISelect[];
  private catalogEducationLevels: ISelect[];
  private catalogDocumentsReceived: ISelect[];
  private catalogAvailabilitys: ISelect[];
  private catalogReasonsOfExit: ISelect[];
  private catalogTrademarks: Observable<IDtoCatalog[]>;
  private catalogPatrimonialRegimes: Observable<IDtoCatalog[]>;
  private catalogSkills: ISelect[];
  private catalogTrackingStatus: ISelect[];
  private catalogTowns: ISelect[];
  private catalogRecruiters: ISelect[];
  private catalogDocuments: Observable<IDocument[]>;
  private generalData = {} as IGeneralData;
  private study = {} as IStudy;
  private employmentHistory: IEmploymentHistory;
  private appearance: IAppearance;
  /**Variable de trasporte de datos */
  private result: IResult;
  /**Radios */
  private hasChildren: boolean;
  private isForeigner: number;
  private isFieldWork: number;
  private hasCar: boolean;
  private hasValidID: boolean;
  private hasFamilyWorking: boolean;
  private hasInfonavit: boolean;
  private hasTattoo: boolean;
  private hasPiercing: boolean;
  private hasDisease: boolean;
  private hasSurgery: boolean;
  private hasDebt: boolean;
  private gender: string;
  /**Listas */
  private workHistories = [];
  private tempWorkHistories = [];
  private tempReferences = [];
  private references = [];
  /** */
  @ViewChild(DatatableComponent, { static: false }) tableWorkHistories: DatatableComponent;
  @ViewChild(DatatableComponent, { static: false }) tableReferences: DatatableComponent;
  /** */
  @ViewChild('tab1', { static: false }) private tab1;
  @ViewChild('tab2', { static: false }) private tab2;
  @ViewChild('tab3', { static: false }) private tab3;
  @ViewChild('tab4', { static: false }) private tab4;
  @ViewChild('tab5', { static: false }) private tab5;
  @ViewChild('tab6', { static: false }) private tab6;
  private referenceTypeLabelsMap = {
    'F': '<p><span class="label label-info">Familiar</span></p>',
    'P': '<p><span class="label label-success">Personal</span></p>'
  };
  /**Variables */
  private now: number;
  private section: string;
  public nav: any;
  private action = 'new';
  private routeType: string;
  private file: File;
  private navigationSubscription: any;
  private employmentHistoryItem: IEmploymentHistoryItem;
  public constructor(private modalService: BsModalService
    , private recruitmentService: RecruitmentService
    , private openingService: OpeningService
    , private formBuilder: FormBuilder
    , public configGeneral: AppConfig
    , private router: Router
    , private route: ActivatedRoute
    , private spinner: NgxSpinnerService
    , private configurationService: ConfigurationService
    , private securityService: SecurityService
    , private dialogService: DialogService
    , private customerService: CustomerService
    , private identityService: IdentityService) {
    this.nav = document.querySelector('nav.navbar');
    this.initializeFormGeneralData();
    this.initializeFormEmploymentHistory();
    this.initializeFormStudy();
    this.initializeFormRecruiterComments();
    this.initializeFormDocuments();
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.initialiseRoute();
      }
    });
  }
  private initialiseRoute() {
    this.resetForm();
  }
  public ngOnDestroy(): any {
    this.nav.classList.remove('white-bg');
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }
  validarApellidos() {
    const apellidoPaterno = this.formGeneralData.get('lastName').value;
  const apellidoMaterno = this.formGeneralData.get('secondLastName').value;

  if (!apellidoPaterno && !apellidoMaterno) {
    return false;
  }

  const trimmedPaterno = apellidoPaterno ? apellidoPaterno.trim() : '';
  const trimmedMaterno = apellidoMaterno ? apellidoMaterno.trim() : '';

  if (trimmedPaterno.length === 0 && trimmedMaterno.length === 0) {
    return false;
  }

    return true;
  }

  public ngOnInit(): any {
    if (this.configurationService.isReady) {
      this.obetenerCatalogos();
    } else {
      this.configurationService.settingsLoaded$.subscribe(x => {
        this.obetenerCatalogos();
      });
    }
    this.generalData.registryDate = new Date();
    this.generalData.lasUpdateDate = new Date();
    //this.nav.className += ' white-bg';

    this.route.params.subscribe((params) => {
      if (params['id']) {
        setTimeout(() => {
          this.spinner.show();
          this.getJobCandidate(Number(params['id']));
          this.action = params['action'];
          this.routeType = params['routeType'];
          if (this.selectRecruiter != undefined) {
            (<any>this.selectRecruiter).setDisabledState(true);
          }
        }, 2);

      }
    });
  }
  private onFileChange(event) {
    event.value = '';
  }
  private access(): boolean {
    const profile = this.securityService.getProfileStorage('Request');
    return profile !== 'Usuario'
  }
  private accessWrite(): boolean {
    const profile = this.securityService.getProfileStorage('Request');
    return profile !== 'Consulta'
  }
  private accessComments(): boolean {
    const profile = this.securityService.getProfileStorage('Request');
    if (profile == 'Consulta' || profile == 'Usuario') {
      return false;
    } else {
      return true;
    }
  }
  private handleFileInput(item: IDocument, files: FileList) {
    const file = files.item(0);
    let ext = file.name.split('.').pop().toLowerCase();;
    if (this.validateExt(ext, item.type)) {
      this.upload(item, file);
    } else {
      this.configGeneral.newToast('Validación', `Asegúrese de seleccionar el tipo de archivo correcto (${item.type})`, 'error');
    }
  }
  private validateExt(ext: string, listExts: string): boolean {
    const list = listExts.split(',').map(x => x.trim().toLowerCase());
    const e = list.filter(x => x === `.${ext}`)[0];
    if (e == undefined) {
      return false
    } else {
      return true;
    }
  }
  // private validateExtension(ext: string, item: IDocument): boolean {
  //   switch (item.documentName) {
  //     case 'Foto':
  //       if (this.validateExt(ext, item.type)) {
  //         return true;
  //       } else {
  //         return false;
  //       }
  //     default:
  //       if (this.validateExt(ext, item.type)) {
  //         return true;
  //       } else {
  //         return false;
  //       }
  //   }
  // }
  private upload(item: IDocument, file: File): void {
    this.spinner.show();
    if (this.generalData.id === undefined || this.generalData.id === 0) {
      this.spinner.hide();
      this.configGeneral.newToast('Validación', 'Capture y guarde información general primeramente', 'error');
      return;
    }
    //const file = files.item(0);
    if (file.size > 2097152) {
      this.spinner.hide();
      this.configGeneral.newToast('Validación', 'No es posible subir documentos con un peso mayor a 2MB', 'error');
      return;
    }
    item.fileName = file.name;
    item.jobCandidateId = this.generalData.id;
    item.id = 0;
    this.recruitmentService.uploadFile(item, file).subscribe((res) => {
      if (res.isCorrect === true) {
        const doc = res.data as IDocument;
        item.fileName = doc.fileName;
        item.path = doc.path;
        item.id = doc.id;
        this.spinner.hide();
        this.configGeneral.newToast('Éxito', 'Documento cargado correctamente', 'success');
      } else {
        this.configGeneral.newToast('Error', res.message, 'error');
        this.spinner.hide();
      }
    },
      (errMessage) => {
        this.spinner.hide();
        this.configGeneral.newToast('Error', errMessage.error.message, 'error');
      });
  }
  private deleteFile(item: IDocument): void {
    if (item.id == undefined) {
      return;
    }
    this.recruitmentService.deleteFile(item.id).subscribe((res) => {
      if (res.isCorrect === true) {
        item.fileName = undefined;
        item.path = undefined;
        item.id = undefined;
        this.configGeneral.newToast('Éxito', 'Documento eliminado correctamente', 'success');
      }
    });
  }
  private downloadFile(item: IDocument): void {
    if (item.id == undefined) {
      return;
    }
    this.recruitmentService.downloadFile(item.id).subscribe((res) => {
      if (res.isCorrect === true) {
        const file = res.data as any;
        const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
        saveAs(blob, file.fileDownloadName);
      }
    });
  }
  private getJobCandidate(jobCandidateId: number): void {
    this.recruitmentService.getJobCandidate(jobCandidateId).subscribe((res) => {
      this.generalData = res;

      if (this.generalData.ageChildrens != null){
        const childrens = this.generalData.ageChildrens.split(",");
        const maxChildren = 5;

        const NameChildrenArray = [this.generalData.nameChildren1, this.generalData.nameChildren2, this.generalData.nameChildren3, this.generalData.nameChildren4, this.generalData.nameChildren5];
        const AgeChildrenArray = [this.generalData.ageChildren1, this.generalData.ageChildren2, this.generalData.ageChildren3, this.generalData.ageChildren4, this.generalData.ageChildren5];

        const assignNameAndAge = (nameIndex: number, ageIndex: number, name: string, age: number) => {
            NameChildrenArray[nameIndex] = name;
            AgeChildrenArray[ageIndex] = age;
        };

        for (let i = 0; i < Math.min(childrens.length, maxChildren); i++) {
            const child = childrens[i];
            const [name, ageString] = child.split(" - ");
            let age = parseInt(ageString);
            if (isNaN(age)) {
              age = null;
          }
            assignNameAndAge(i, i, name.trim(), age);
        }

        [this.generalData.nameChildren1, this.generalData.nameChildren2, this.generalData.nameChildren3, this.generalData.nameChildren4, this.generalData.nameChildren5] = NameChildrenArray;
        [this.generalData.ageChildren1, this.generalData.ageChildren2, this.generalData.ageChildren3, this.generalData.ageChildren4, this.generalData.ageChildren5] = AgeChildrenArray;
      }

      this.getCatalogTowns(this.generalData.stateId);
      this.getCatalogStateBirth(this.generalData.countryId.toString());
      this.setJobCandidateGeneralData();
      this.setJobCandidateEmploymentHistory();
      this.setJobCandidateStudy();
      this.setJobCandidateRecruiterComment();
      if (this.generalData.jobCandidateDocuments != null) {
        if (this.generalData.jobCandidateDocuments.length > 0) {
          this.catalogDocuments.subscribe((docs) => {
            docs.forEach(element => {
              const d = this.generalData.jobCandidateDocuments.filter(x => x.documentName === element.documentName)[0];
              if (d !== undefined) {
                element.fileName = d.fileName;
                element.path = d.path;
                element.id = d.id;
              }
            });
          })
        }
      }
      this.spinner.hide();
    });
  }
  private navigateTo(): void {
    this.resetForm();
    this.router.navigate(['/recruitments/request'], { relativeTo: this.route });
  }
  private resetForm(): void {
    if (this.selectRecruiter != undefined) {
      (<any>this.selectRecruiter).setDisabledState(false);
    }
    this.generalData = {} as IGeneralData;
    this.generalData.registryDate = new Date();
    this.generalData.lasUpdateDate = new Date();
    this.action = 'new';
    this.formGeneralData.reset();
    this.formEmploymentHistory.reset();
    this.formStudy.reset();
    this.formRecruiterComments.reset();
    this.workHistories = [];
    this.tempWorkHistories = [];
    this.tempReferences = [];
    this.references = [];
    this.appearance = null;
    if (this.catalogDocuments != undefined) {
      this.catalogDocuments.subscribe((docs) => {
        docs.forEach(element => {
          element.fileName = undefined;
          element.path = undefined;
          element.id = undefined;
        });
      })
    }
  }
  private isNew(): boolean {
    if (this.generalData.id === undefined || this.generalData.id === 0) {
      return true;
    }
  }
  private validateSectionReferences(): boolean {
    if (this.section === 'references') {
      if (this.references === undefined || this.references === null || this.references.length === 0) {
        this.tab3.nativeElement.checked = true;
        this.configGeneral.newToast('Validación', 'Debe capturar por lo menos 1 referencia personal y 1 familiar', 'warning');
        return false;
      }
      const numRefFam = this.references.filter(x => x.referenceType === 'F').length;
      const numRefPer = this.references.filter(x => x.referenceType === 'P').length;
      if (numRefFam < 1 || numRefPer < 1) {
        this.tab3.nativeElement.checked = true;
        this.configGeneral.newToast('Validación', 'Debe capturar por lo menos 1 referencia personal y 1 familiar', 'warning');
        return false;
      }
    }
    return true;
  }
  private setSectionGeneralData(): void {
    if (this.isNew()) {
      return;
    }
    if (this.validateSectionReferences()) {
      this.section = 'generalData';
    }
  }
  private setSectionEmploymentHistory(): void {
    if (this.isNew()) {
      return;
    }
    if (this.validateSectionReferences()) {
      this.section = 'employmentHistory';
    }
  }
  private setSectionReferences(): void {
    if (this.isNew()) {
      return;
    }
    if (this.access()) {
      return;
    }
    if (this.validateSectionReferences()) {
      this.section = 'references';
    }
  }
  private setSectionStudy(): void {
    if (this.isNew()) {
      return;
    }
    if (this.validateSectionReferences()) {
      this.section = 'study';
    }
  }
  private setSectionRecruiterComments(): void {
    if (this.isNew()) {
      return;
    }
    if (this.validateSectionReferences()) {
      this.section = 'recruiterComments';
    }
  }
  private setSectionDocuments(): void {
    if (this.isNew()) {
      return;
    }
    if (this.validateSectionReferences()) {
      this.section = 'documents';
    }
  }
  private obetenerCatalogos(): void {
    this.getCatalogStates();
    this.getCatalogZones();
    this.getCatalogMaritalStatus();
    this.getCatalogSources();
    this.getCatalogSizes();
    this.getCatalogShirtSizes();
    this.getCatalogPhoneCompanies();
    this.getCatalogPhonePlans();
    this.getCatalogPhysicalComplexions();
    this.getCatalogSchoolLevels();
    this.getCatalogMaritalStatus();
    this.getCatalogStatures();
    this.getCatalogShoeSizes();
    this.getCatalogPositions();
    //this.getCatalogRequisitions();
    this.getCatalogEducationLevels();
    this.getCatalogDocumentsReceived();
    this.getCatalogAvailabilitys();
    this.getCatalogReasonsOfExit();
    this.getCatalogSkills();
    this.getCatalogTrackingStatus();
    this.getCatalogRecruiters();
    this.getCatalogCountries();
    this.catalogDocuments = this.recruitmentService.getCatalogDocumens();
    this.catalogTrademarks = this.customerService.getCatalogCustomers();
    this.catalogPatrimonialRegimes = this.recruitmentService.getCatalogPatrimonialRegimes();
    this.catalogDocuments.subscribe((docs) => {
      docs.forEach(element => {
        element.fileName = null;
        element.path = null;
        element.id = null;
      });
    });
  }
  private radioChange($event: MatRadioChange) {
    switch ($event.source.name) {
      case 'hasChildren':
        this.hasChildren = $event.value;
        break;
      case 'typePosition':
        this.isFieldWork = $event.value;
        if (this.isFieldWork === 0) {
          this.openModalAppearance();
        }
        break;
      case 'nationality':
        this.isForeigner = $event.value;
        if (this.isForeigner === 1) {
          this.formGeneralData.get('countryId').setValidators([Validators.required, Validators.maxLength(100)]);
          this.formGeneralData.get('countryId').setValue(null);
          this.catalogStateBirth = null;
        } else {
          this.formGeneralData.get('countryId').setValidators(null);
          this.formGeneralData.get('countryId').setValue('1');
          this.getCatalogStateBirth('1');
        }
        this.formGeneralData.get('countryId').updateValueAndValidity();
        break;
      case 'hasCar':
        this.hasCar = $event.value;
        if (this.hasCar) {
          this.formRecruiterComments.get('carDescription').setValidators([Validators.required, Validators.maxLength(1000)]);
        } else {
          this.formRecruiterComments.get('carDescription').setValidators(null);
        }
        this.formRecruiterComments.get('carDescription').updateValueAndValidity();
        break;
      case 'hasValidID':
        this.hasValidID = $event.value;
        if (!this.hasValidID) {
          this.formRecruiterComments.get('idReason').setValidators([Validators.required, Validators.maxLength(500)]);
        } else {
          this.formRecruiterComments.get('idReason').setValidators(null);
        }
        this.formRecruiterComments.get('idReason').updateValueAndValidity();
        break;
      case 'hasFamilyWorking':
        this.hasFamilyWorking = $event.value;
        if (this.hasFamilyWorking) {
          this.formRecruiterComments.get('familyName').setValidators([Validators.required, Validators.maxLength(150)]);
          this.formRecruiterComments.get('trademarkWork').setValidators([Validators.required, Validators.maxLength(200)]);
          this.formRecruiterComments.get('familyRelationship').setValidators([Validators.required, Validators.maxLength(200)]);
        } else {
          this.formRecruiterComments.get('familyName').setValidators(null);
          this.formRecruiterComments.get('trademarkWork').setValidators(null);
          this.formRecruiterComments.get('familyRelationship').setValidators(null);
        }
        this.formRecruiterComments.get('familyName').updateValueAndValidity();
        this.formRecruiterComments.get('trademarkWork').updateValueAndValidity();
        this.formRecruiterComments.get('familyRelationship').updateValueAndValidity();
        break;
      case 'hasInfonavit':
        this.hasInfonavit = $event.value;
        if (this.hasInfonavit) {
          this.formRecruiterComments.get('monthlyDiscount').setValidators([Validators.required]);
        } else {
          this.formRecruiterComments.get('monthlyDiscount').setValidators(null);
        }
        this.formRecruiterComments.get('monthlyDiscount').updateValueAndValidity();
        break;
      case 'hasTattoo':
        this.hasTattoo = $event.value;
        if (this.hasTattoo) {
          this.formRecruiterComments.get('tattooComments').setValidators([Validators.required, Validators.maxLength(500)]);
        } else {
          this.formRecruiterComments.get('tattooComments').setValidators(null);
        }
        this.formRecruiterComments.get('tattooComments').updateValueAndValidity();
        break;
      case 'hasPiercing':
        this.hasPiercing = $event.value;
        if (this.hasPiercing) {
          this.formRecruiterComments.get('piercingComments').setValidators([Validators.required, Validators.maxLength(500)]);
        } else {
          this.formRecruiterComments.get('piercingComments').setValidators(null);
        }
        this.formRecruiterComments.get('piercingComments').updateValueAndValidity();
        break;
      case 'hasDisease':
        this.hasDisease = $event.value;
        if (this.hasDisease) {
          this.formRecruiterComments.get('diseaseComments').setValidators([Validators.required, Validators.maxLength(500)]);
        } else {
          this.formRecruiterComments.get('diseaseComments').setValidators(null);
        }
        this.formRecruiterComments.get('diseaseComments').updateValueAndValidity();
        break;
      case 'hasSurgery':
        this.hasSurgery = $event.value;
        if (this.hasSurgery) {
          this.formRecruiterComments.get('surgeryComments').setValidators([Validators.required, Validators.maxLength(500)]);
        } else {
          this.formRecruiterComments.get('surgeryComments').setValidators(null);
        }
        this.formRecruiterComments.get('surgeryComments').updateValueAndValidity();
        break;
      case 'hasDebt':
        this.hasDebt = $event.value;
        if (this.hasDebt) {
          this.formRecruiterComments.get('debitBank').setValidators([Validators.required, Validators.maxLength(200)]);
          this.formRecruiterComments.get('debtAmount').setValidators([Validators.required]);
        } else {
          this.formRecruiterComments.get('debitBank').setValidators(null);
          this.formRecruiterComments.get('debtAmount').setValidators(null);
        }
        this.formRecruiterComments.get('debitBank').updateValueAndValidity();
        this.formRecruiterComments.get('debtAmount').updateValueAndValidity();
        break;
      case 'gender':
        this.gender = $event.value;
        this.catalogGenderSizes = this.catalogSizes.filter(x => x.additional === this.gender);
        break;
    }
  }
  public getError(controlName: string): any {
    let error = '';
    let obj = {} as any;
    const control = this.formGeneralData.get(controlName);
    switch (controlName) {
      case 'stateBirth':
      case 'state':
      case 'maritalStatus':
      case 'hasChildren':
      case 'schoolLevel':
      case 'typePosition':
      case 'interestPosition':
      case 'recruitmentSource':
      case 'patrimonialRegimeId':
      case 'phoneCompany':
        if (control.errors != null) {
          error = JSON.stringify(control.errors);
          obj = JSON.parse(error);
        }
        break;
      default:
        if (control.touched && control.errors != null) {
          error = JSON.stringify(control.errors);
          obj = JSON.parse(error);
        }
        break;
    }

    return obj;
  }
  private dateChange($event: Date) {
    this.formGeneralData.get('age').setValue(this.calculateAge($event));
  }
  private calculateAge(birthDate: Date): number {
    let age = 0;
    if (birthDate) {
      const timeDiff = Math.abs(Date.now() - birthDate.getTime());
      age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
    }
    return age;
  }
  private initializeFormGeneralData() {
    this.formGeneralData = this.formBuilder.group({
      firstName: [null, [Validators.required, Validators.maxLength(50)]],
      lastName: [null, [Validators.maxLength(40)]],
      secondLastName: [null, Validators.maxLength(40)],
      birthDate: [null, Validators.required],
      age: [null],
      stateBirth: [null, Validators.required],
      gender: [null, Validators.required],
      curp: [null, [Validators.required, Validators.minLength(18), Validators.maxLength(18)]],
      rfc: [null, [Validators.required, Validators.minLength(13), Validators.maxLength(13)]],
      imss: [null, [Validators.required, Validators.minLength(11), Validators.maxLength(11)]],
      typePosition: [null, Validators.required],
      interestPosition: [null, Validators.required],
      recruitmentSource: [null, Validators.required],
      sourceName: [null, [Validators.required, Validators.maxLength(100)]],
      personalNumber: [null, [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      phone: [null, [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      email: [null, [Validators.required, Validators.email, Validators.maxLength(100)]],
      maritalStatus: [null, Validators.required],
      hasChildren: [null, Validators.required],
      ageChildrens: [null],
      street: [null, [Validators.required, Validators.maxLength(100)]],
      interiorNumber: [null, Validators.maxLength(10)],
      externalNumber: [null, [Validators.required, Validators.maxLength(10)]],
      postalCode: [null, [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
      suburb: [null, [Validators.required, Validators.maxLength(50)]],
      state: [null, Validators.required],
      town: [null, Validators.required],
      nationality: [null, Validators.required],
      nationalityName: [null],
      countryId: [null],
      schoolLevel: [null, Validators.required],
      recruiterId: [null, Validators.required],
      patrimonialRegimeId: [null],
      taxStreet: [null],
      taxInteriorNumber: [null],
      taxExternalNumber: [null],
      taxPostalCode: [null],
      taxSuburb: [null],
      taxState: [null],
      taxTown: [null],
      phoneCompanyId: [null, Validators.required],
      phonePlanId: [null, Validators.required],
      nameChildren1: [null],
      nameChildren2: [null],
      nameChildren3: [null],
      nameChildren4: [null],
      nameChildren5: [null],
      ageChildren1: [null],
      ageChildren2: [null],
      ageChildren3: [null],
      ageChildren4: [null],
      ageChildren5: [null],
    });
  }
  private initializeFormEmploymentHistory() {
    this.formEmploymentHistory = this.formBuilder.group({
      monthlySalary: [null, [Validators.required]],
      availability: [null, Validators.required],
      hasExperience: [null, Validators.required],
      comments: [null, [Validators.maxLength(1000)]]
    });
  }
  private initializeFormStudy() {
    this.formStudy = this.formBuilder.group({
      schoolLevel: [null, Validators.required],
      levelEducation: [null, Validators.required],
      institute: [null, [Validators.required, Validators.maxLength(100)]],
      documentReceived: [null, Validators.required],
      periodFrom: [null, Validators.required],
      periodTo: [null, Validators.required]
    });
  }
  private initializeFormDocuments() {
    this.formDocuments = this.formBuilder.group({
      tableDocuments: [null]
    });
  }
  private initializeFormRecruiterComments() {
    this.formRecruiterComments = this.formBuilder.group({
      positionNOM: [null, Validators.required],
      hasCar: [null, Validators.required],
      hasHouse: [null, Validators.required],
      carDescription: [null],
      hasDebt: [null, Validators.required],
      debitBank: [null],
      debtAmount: [null],
      monthlyExpense: [null, Validators.required],
      hasValidID: [null, Validators.required],
      hasFamilyWorking: [null, Validators.required],
      familyName: [null],
      trademarkWork: [null],
      hasInfonavit: [null, Validators.required],
      monthlyDiscount: [null],
      hasTattoo: [null, Validators.required],
      tattooComments: [null],
      hasPiercing: [null, Validators.required],
      piercingComments: [null],
      hasDisease: [null, Validators.required],
      diseaseComments: [null],
      hasSurgery: [null, Validators.required],
      alimony: [null, Validators.required],
      surgeryComments: [null],
      trackingStatus: [null],
      trademark: [null, Validators.required],
      skill: [null],
      additionalComments: [null, [Validators.maxLength(1000)]],
      responsableName: [null, [Validators.required, Validators.maxLength(150)]],
      responsablePositionId: [null, Validators.required],
      idReason: [null],
      trademarkId: [null, Validators.required],
      positionType: [null, Validators.required],
      availabilityTravel: [null, Validators.required],
      familyRelationship: [null],
    });
  }
  private openModalEmploymentmentHistory(item: any, action: string) {
    if (this.generalData.id === undefined || this.generalData.id === 0) {
      this.configGeneral.newToast('Validación', 'Capture y guarde información general primeramente', 'error');
      return;
    }
    const catalogs = new Array() as Array<ISelect[]>;
    catalogs.push(this.catalogReasonsOfExit);
    const initialState = {
      employmentHistoryItem: item,
      listCatalogs: catalogs,
      title: 'Alta de historial de candidato'
    };
    this.modalRef = this.modalService.show(ModalEmploymentHistoryComponet
      , Object.assign({ initialState }
        , { class: 'modal-lg' }
        , this.configModal));
    this.modalRef.content.onClose.subscribe((result) => {
      if (result) {
        if (result.id > 0) {
          const index = this.workHistories.indexOf(item, 0);
          if (index > -1) {
            this.workHistories.splice(index, 1);
          }
          this.workHistories.push(result);
          this.workHistories = [...this.workHistories];
        } else {
          if (action === 'edit') {
            const index = this.workHistories.indexOf(item, 0);
            if (index > -1) {
              this.workHistories.splice(index, 1);
            }
            this.workHistories.push(result);
            this.workHistories = [...this.workHistories];
          } else {
            this.workHistories.push(result);
            this.workHistories = [...this.workHistories];
          }
        }
        this.configGeneral.newToast('Validación', 'Debe presionar Guardar datos para procesar correctamente la información', 'warning');
      } else {
        this.configGeneral.newToast('Error', 'Ocurrió un error al intentar guardar los datos, intente de nuevo', 'error');
      }
    });
  }
  private openModalHistoryComments(item: IEmploymentHistoryItem) {
    const initialState = {
      historyItem: item,
      title: 'Comentario laboral de reclutamiento'
    };
    this.modalRef = this.modalService.show(ModalEmploymentHistoryCommentsComponent
      , Object.assign({ initialState }
        , this.configModal));
    this.modalRef.content.onClose.subscribe((result) => {
      if (result) {
        item.commentHistory = result.commentHistory;
        this.workHistories = [...this.workHistories]
        this.configGeneral.newToast('Éxito', 'Comentarios guardados correctamente', 'success');
      } else {
        this.configGeneral.newToast('Error', 'Ocurrió un error al intentar guardar los datos, intente de nuevo', 'error');
      }
    });
  }
  private openModalLanguage(item: any, accion: string) {
    const initialState = {
      title: 'Alta de idiomas del candidato'
    };
    this.modalRef = this.modalService.show(ModalLanguageComponet
      , Object.assign({ initialState }
        , { class: 'modal-lg' }
        , this.configModal));
  }
  private openModalReference(item: any, accion: string) {
    if (this.generalData.id === undefined || this.generalData.id === 0) {
      this.configGeneral.newToast('Validación', 'Capture y guarde información general primeramente', 'error');
      return;
    }
    const initialState = {
      jobCandidateId: this.generalData.id,
      title: 'Alta de referencia familiar/personal del candidato'
    };
    this.modalRef = this.modalService.show(ModalReferenceComponet
      , Object.assign({ initialState }
        , { class: 'modal-lg' }
        , this.configModal));
    this.modalRef.content.onClose.subscribe((result) => {
      if (result) {
        if (this.references === null) {
          this.references = [];
        }
        this.references.push(result);
        this.references = [...this.references]
        this.configGeneral.newToast('Éxito', 'Registros guardados correctamente', 'success');
      } else {
        this.configGeneral.newToast('Error', 'Ocurrió un error al intentar guardar los datos', 'error');
      }
    });
  }
  private openModalStudy(item: any, accion: string) {
    const initialState = {
      title: 'Alta de estudios del candidato'
    };
    this.modalRef = this.modalService.show(ModalStudyComponet
      , Object.assign({ initialState }
        , { class: 'modal-lg' }
        , this.configModal));
  }
  private openModalAppearance() {
    if (this.formGeneralData.controls['gender'].value === null) {
      this.configGeneral.newToast('Validación', 'Es necesario capturar primero su sexo', 'error');
      return;
    }
    const catalogs = new Array() as Array<ISelect[]>;
    catalogs.push(this.catalogGenderSizes);
    catalogs.push(this.catalogPhysicalComplexion);
    catalogs.push(this.catalogStatures);
    catalogs.push(this.catalogShoeSizes);
    catalogs.push(this.catalogShirtSizes);
    const initialState = {
      listCatalogs: catalogs,
      title: 'Información de complexión física del candidato',
      action: this.action,
      appearance: this.appearance
    };
    this.modalRef = this.modalService.show(ModalAppearanceComponet
      , Object.assign({ initialState }
        , this.configModal));
    this.modalRef.content.onClose.subscribe((result) => {
      if (result) {
        this.appearance = result;
      }
    });
  }
  private submitDeleteEmploymentHistoryItem(item: IEmploymentHistoryItem) {
    this.employmentHistoryItem = item;
    this.deleteSwal.title = 'Se eliminará el historial laboral seleccionado.';
    this.deleteSwal.show();
  }
  private deleteEmploymentHistoryItem(): void {
    if (this.employmentHistoryItem.id > 0) {
      this.recruitmentService.deleteEmploymentHistoyItem(this.employmentHistoryItem.id).subscribe(
        (x) => {
          this.configGeneral.newToast('Éxito', x.message, 'success');
          const index = this.workHistories.indexOf(this.employmentHistoryItem, 0);
          if (index > -1) {
            this.workHistories.splice(index, 1);
          }
          //this.workHistories = [...this.removeEmploymentHistoryItem(this.employmentHistoryItem.id)];
          this.workHistories = [...this.workHistories];
        });
    } else {
      const index = this.workHistories.indexOf(this.employmentHistoryItem, 0);
      if (index > -1) {
        this.workHistories.splice(index, 1);
      }
      this.workHistories = [...this.workHistories];
    }
  }
  private removeEmploymentHistoryItem(id) {
    return this.workHistories.filter(function (element) {
      return element.id != id;
    });
  }
  submitForm(formName: string, form: FormGroup) {
    this.section = formName;
    if (form.valid) {
      switch (this.section) {
        case 'generalData':
          if (this.formGeneralData.value.typePosition === 0) {
            if (this.appearance === null || this.appearance === undefined) {
              this.configGeneral.newToast('Validación', 'Es necesario capturar su información de apariencia para poder continuar', 'error');
              return;
            }
          }
          if (!this.validarApellidos()) {
            this.configGeneral.newToast('Validación', `Debe escribir al menos un apellido`, 'error');
            return;
          }
          break;
        case 'study':
          if (this.generalData.id === undefined || this.generalData.id === 0) {
            this.configGeneral.newToast('Validación', 'Capture y guarde información general primeramente para poder guardar esta sección', 'error');
            return;
          }
          break;
        case 'employmentHistory':
          if (this.generalData.id === undefined || this.generalData.id === 0) {
            this.configGeneral.newToast('Validación', 'Capture y guarde información general primeramente para poder guardar esta sección', 'error');
            return;
          }
          if (this.formEmploymentHistory.value.hasExperience) {
            if (this.workHistories.length === 0) {
              this.configGeneral.newToast('Validación', 'No existe historial laboral. Capture para poder guardar esta sección', 'warning');
              return;
            }
          }
          break;
        case 'recruiterComments':
          if (this.generalData.id === undefined || this.generalData.id === 0) {
            this.configGeneral.newToast('Validación', 'Capture y guarde información general primeramente para poder guardar esta sección', 'error');
            return;
          }
          break;
      }
      this.addSwal.title = 'Sus datos serán enviados a reclutamiento para su revisión.';
      this.addSwal.show();
    } else {
      this.touchedControls(form);
      this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continua', 'error');
    }
  }
  save(): void {
    let data: any;
    switch (this.section) {
      case 'generalData':
        data = this.mapGeneralData(this.formGeneralData.value);
        break;
      case 'study':
        data = this.mapStudy(this.formStudy.value);
        break;
      case 'employmentHistory':
        data = this.mapEmploymentHistory(this.formEmploymentHistory.value);
        break;
      case 'recruiterComments':
        data = this.mapRecruiterComments(this.formRecruiterComments.value);
        break;
    }
    switch (this.action) {
      case 'update':
        this.spinner.show();
        this.recruitmentService.updateRecluitment(this.section, data).subscribe(
          (x) => {
            this.result = x;
            if (this.result.isCorrect === true) {
              switch (this.section) {
                case 'generalData':
                  break;
                case 'study':
                  this.generalData.jobCandidateLevelEducation = this.result.data as IStudy;
                  this.setJobCandidateStudy();
                  break;
                case 'employmentHistory':
                  this.generalData.jobCandidateEmploymentHistory = this.result.data as IEmploymentHistory;
                  this.setJobCandidateEmploymentHistory();
                  break;
                case 'recruiterComments':
                  this.generalData.jobCandidateRecruiterComment = this.result.data as IRecruiterComment;
                  this.setJobCandidateRecruiterComment();
                  break;
              }
              this.spinner.hide();
              this.configGeneral.newToast('Éxito', 'Registros guardados correctamente', 'success');
              this.addModuleLog();
            } else {
              this.configGeneral.newToast('Error', this.result.message, 'error');
              this.spinner.hide();
            }
          },
          (errMessage) => this.errorMessages = errMessage.messages);
        break;
      case 'new':
        this.spinner.show();
        this.recruitmentService.addRecluitment(this.section, data).subscribe(
          (x) => {
            this.result = x;
            if (this.result.isCorrect === true) {
              switch (this.section) {
                case 'generalData':
                  this.generalData = this.result.data as IGeneralData;
                  this.setJobCandidateGeneralData();
                  this.tab2.nativeElement.checked = true;
                  break;
                case 'study':
                  this.generalData.jobCandidateLevelEducation = this.result.data as IStudy;
                  this.setJobCandidateStudy();
                  this.tab4.nativeElement.checked = true;
                  break;
                case 'employmentHistory':
                  this.generalData.jobCandidateEmploymentHistory = this.result.data as IEmploymentHistory;
                  this.setJobCandidateEmploymentHistory();
                  this.tab3.nativeElement.checked = true;
                  break;
                case 'recruiterComments':
                  this.generalData.jobCandidateRecruiterComment = this.result.data as IRecruiterComment;
                  this.setJobCandidateRecruiterComment();
                  break;
              }
              this.spinner.hide();
              this.configGeneral.newToast('Éxito', 'Registros guardados correctamente', 'success');
              this.addModuleLog();
            } else {
              this.configGeneral.newToast('Error', this.result.message, 'error');
              this.spinner.hide();
            }
          },
          (errMessage) => this.errorMessages = errMessage.messages);
        break;
    }
  }
  private addModuleLog(): void {
    let dto = {} as IDtoModuleLog;
    dto.table = "JobCandidates";
    dto.module = "Request";
    dto.action = this.action;
    dto.registryAffectedId = this.generalData.id;
    this.identityService.addModuleLog(dto).subscribe(
      (x) => { });
  }
  private touchedControls(form: FormGroup): void {
    Object.keys(form.controls).forEach(field => {
      const control = form.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }
  private mapGeneralData(form: any): IGeneralData {
    const data = {} as IGeneralData;
    data.firstName = form.firstName.trim();
    if (form.lastName != null){
    data.lastName = form.lastName.trim();
    }
    else{
      data.lastName = '';
    };
    if (form.secondLastName != null){
      data.secondLastName = form.secondLastName.trim();}
    else{
      data.secondLastName = '';
    };
    data.birthDate = new Date(this.configGeneral.dateFormat(form.birthDate, 'mm/dd/yyyy'));
    data.age = form.age;
    data.stateBirthId = form.stateBirth;
    data.gender = form.gender;
    data.curp = form.curp.trim();
    data.rfc = form.rfc.trim();
    data.imss = form.imss.trim();
    data.typePosition = form.typePosition;
    data.interestPositionId = form.interestPosition;
    data.recruitmentSourceId = form.recruitmentSource;
    data.sourceName = form.sourceName.trim();
    data.personalNumber = form.personalNumber;
    data.phone = form.phone;
    data.email = form.email.trim();
    data.maritalStatusId = form.maritalStatus;
    data.patrimonialRegimeId = form.patrimonialRegimeId;
    data.hasChildren = form.hasChildren;

const childrenInfo = [
  { name: form.nameChildren1, age: form.ageChildren1 },
  { name: form.nameChildren2, age: form.ageChildren2 },
  { name: form.nameChildren3, age: form.ageChildren3 },
  { name: form.nameChildren4, age: form.ageChildren4 },
  { name: form.nameChildren5, age: form.ageChildren5 }
];

const formattedChildrenInfo = childrenInfo
  .filter(child => child.name && child.age)
  .map(child => `${child.name} - ${child.age} años`)
  .join(', ');

  data.ageChildrens = formattedChildrenInfo

    data.street = form.street.trim();
    data.interiorNumber = form.interiorNumber;
    data.externalNumber = form.externalNumber.trim();
    data.suburb = form.suburb.trim();
    data.postalCode = form.postalCode;
    data.stateId = form.state;
    data.townId = form.town;
    data.nationality = form.nationality;
    data.nationalityName = form.nationalityName;
    data.countryId = form.countryId;
    data.schoolLevelId = form.schoolLevel;
    data.registryDate = new Date();
    data.lasUpdateDate = new Date();
    data.isActive = true;
    data.isVisible = true;
    data.jobCandidateStatusId = this.generalData.jobCandidateStatusId === undefined ? 1 : this.generalData.jobCandidateStatusId;
    data.id = this.generalData.id;
    if (this.generalData.jobCandidateAppearance != undefined || this.generalData.jobCandidateAppearance != null) {
      this.appearance.id = this.generalData.jobCandidateAppearance.id;
    }
    if (this.appearance != null) {
      data.jobCandidateAppearance = this.appearance;
      this.appearance.jobCandidateId = this.generalData.id;
    }
    data.profile = this.securityService.getProfileStorage('Request');
    data.recruiterId = form.recruiterId;
    data.phoneCompanyId = form.phoneCompanyId;
    data.phonePlanId = form.phonePlanId;
    return data;
  }
  private setJobCandidateGeneralData(): void {
    /**Datos generales */
    console.log(this.catalogCountries);
    this.formGeneralData.get('firstName').setValue(this.generalData.firstName);
    this.formGeneralData.get('lastName').setValue(this.generalData.lastName);
    this.formGeneralData.get('secondLastName').setValue(this.generalData.secondLastName);
    this.generalData.birthDate = new Date(this.generalData.birthDate);
    this.formGeneralData.get('birthDate').setValue(this.generalData.birthDate);
    this.formGeneralData.get('age').setValue(this.calculateAge(this.generalData.birthDate));
    this.formGeneralData.get('stateBirth').setValue(this.generalData.stateBirthId.toString());
    this.formGeneralData.get('gender').setValue(this.generalData.gender);
    this.catalogGenderSizes = this.catalogSizes.filter(x => x.additional === this.generalData.gender);
    this.formGeneralData.get('curp').setValue(this.generalData.curp);
    this.formGeneralData.get('rfc').setValue(this.generalData.rfc);
    this.formGeneralData.get('imss').setValue(this.generalData.imss);
    this.formGeneralData.get('typePosition').setValue(Number(this.generalData.typePosition));
    this.isFieldWork = Number(this.generalData.typePosition);
    this.formGeneralData.get('interestPosition').setValue(this.generalData.interestPositionId.toString());
    this.formGeneralData.get('recruitmentSource').setValue(this.generalData.recruitmentSourceId.toString());
    this.formGeneralData.get('sourceName').setValue(this.generalData.sourceName);
    this.formGeneralData.get('personalNumber').setValue(this.generalData.personalNumber);
    this.formGeneralData.get('phone').setValue(this.generalData.phone);
    this.formGeneralData.get('email').setValue(this.generalData.email);
    this.formGeneralData.get('maritalStatus').setValue(this.generalData.maritalStatusId.toString());
    this.formGeneralData.get('patrimonialRegimeId').setValue(this.generalData.patrimonialRegimeId);
    this.formGeneralData.get('hasChildren').setValue(this.generalData.hasChildren);
    this.hasChildren = this.generalData.hasChildren;
    this.formGeneralData.get('ageChildrens').setValue(this.generalData.ageChildrens);
    this.formGeneralData.get('street').setValue(this.generalData.street);
    this.formGeneralData.get('interiorNumber').setValue(this.generalData.interiorNumber);
    this.formGeneralData.get('externalNumber').setValue(this.generalData.externalNumber);
    this.formGeneralData.get('suburb').setValue(this.generalData.suburb);
    this.formGeneralData.get('postalCode').setValue(this.generalData.postalCode);
    this.formGeneralData.get('state').setValue(this.generalData.stateId.toString());
    this.formGeneralData.get('town').setValue(this.generalData.townId);
    this.formGeneralData.get('nationality').setValue(Number(this.generalData.nationality));
    this.isForeigner = Number(this.generalData.nationality);
    this.formGeneralData.get('nationalityName').setValue(this.generalData.nationalityName);
    this.formGeneralData.get('countryId').setValue(this.generalData.countryId.toString());
    this.formGeneralData.get('schoolLevel').setValue(this.generalData.schoolLevelId.toString());

    this.formGeneralData.get('nameChildren1').setValue(this.generalData.nameChildren1);
    this.formGeneralData.get('nameChildren2').setValue(this.generalData.nameChildren2);
    this.formGeneralData.get('nameChildren3').setValue(this.generalData.nameChildren3);
    this.formGeneralData.get('nameChildren4').setValue(this.generalData.nameChildren4);
    this.formGeneralData.get('nameChildren5').setValue(this.generalData.nameChildren5);
    this.formGeneralData.get('ageChildren1').setValue(this.generalData.ageChildren1);
    this.formGeneralData.get('ageChildren2').setValue(this.generalData.ageChildren2);
    this.formGeneralData.get('ageChildren3').setValue(this.generalData.ageChildren3);
    this.formGeneralData.get('ageChildren4').setValue(this.generalData.ageChildren4);
    this.formGeneralData.get('ageChildren5').setValue(this.generalData.ageChildren5);

    if (this.generalData.phoneCompanyId != null) {
      this.formGeneralData.get('phoneCompanyId').setValue(this.generalData.phoneCompanyId.toString());
    }
    if (this.generalData.phonePlanId != null) {
      this.formGeneralData.get('phonePlanId').setValue(this.generalData.phonePlanId.toString());
    }
    if (this.generalData.recruiterId != null) {
      this.formGeneralData.get('recruiterId').setValue(this.generalData.recruiterId.toString());
    }
    if (this.generalData.employeeTaxData != null && this.generalData.employeeTaxData.length > 0) {
      let taxData = this.generalData.employeeTaxData[0];
      this.formGeneralData.get('taxStreet').setValue(taxData.street);
      this.formGeneralData.get('taxInteriorNumber').setValue(taxData.interiorNumber);
      this.formGeneralData.get('taxExternalNumber').setValue(taxData.externalNumber);
      this.formGeneralData.get('taxSuburb').setValue(taxData.suburb);
      this.formGeneralData.get('taxPostalCode').setValue(taxData.postalCode);
      this.formGeneralData.get('taxState').setValue(taxData.state);
      this.formGeneralData.get('taxTown').setValue(taxData.town);
    }
    /**Apariencia */
    this.appearance = this.generalData.jobCandidateAppearance;
    /**Referencias */
    this.references = this.generalData.jobCandidateReference;
    this.tempReferences = this.generalData.jobCandidateReference;
  }
  private setJobCandidateEmploymentHistory(): void {
    /**Historial laboral */
    /**Items historial laboral */
    if (this.generalData.jobCandidateEmploymentHistory !== null) {
      this.formEmploymentHistory.get('monthlySalary').setValue(this.generalData.jobCandidateEmploymentHistory.monthlySalaryDesired);
      this.formEmploymentHistory.get('availability').setValue(this.generalData.jobCandidateEmploymentHistory.availabilityId.toString());
      this.formEmploymentHistory.get('hasExperience').setValue(this.generalData.jobCandidateEmploymentHistory.hasExperience);
      this.formEmploymentHistory.get('comments').setValue(this.generalData.jobCandidateEmploymentHistory.comments);
      if (this.generalData.jobCandidateEmploymentHistory.jobCandidateEmploymentHistoryItem !== undefined) {
        this.generalData.jobCandidateEmploymentHistory.jobCandidateEmploymentHistoryItem.forEach(element => {
          element.reasonOfExit = this.catalogReasonsOfExit.filter(x => x.id === element.reasonOfExitId.toString())[0].text;
        });
      }
      this.workHistories = this.generalData.jobCandidateEmploymentHistory.jobCandidateEmploymentHistoryItem;
      this.tempWorkHistories = this.generalData.jobCandidateEmploymentHistory.jobCandidateEmploymentHistoryItem;
    }
  }
  private setJobCandidateStudy(): void {
    /**Datos de estudio */
    if (this.generalData.jobCandidateLevelEducation !== null) {
      this.formStudy.get('schoolLevel').setValue(this.generalData.jobCandidateLevelEducation.schoolLevelId.toString());
      this.formStudy.get('levelEducation').setValue(this.generalData.jobCandidateLevelEducation.educationLevelId.toString());
      this.formStudy.get('institute').setValue(this.generalData.jobCandidateLevelEducation.institute);
      this.formStudy.get('documentReceived').setValue(this.generalData.jobCandidateLevelEducation.documentReceivedId.toString());
      this.generalData.jobCandidateLevelEducation.periodFrom = new Date(this.generalData.jobCandidateLevelEducation.periodFrom);
      this.formStudy.get('periodFrom').setValue(this.generalData.jobCandidateLevelEducation.periodFrom);
      this.generalData.jobCandidateLevelEducation.periodTo = new Date(this.generalData.jobCandidateLevelEducation.periodTo);
      this.formStudy.get('periodTo').setValue(this.generalData.jobCandidateLevelEducation.periodTo);
    }
  }
  private setJobCandidateRecruiterComment(): void {
    /**Datos de estudio */
    if (this.generalData.jobCandidateRecruiterComment !== null) {
      //this.formRecruiterComments.get('positionNOM').setValue(this.generalData.jobCandidateRecruiterComment.positionId.toString());
      this.formRecruiterComments.get('hasHouse').setValue(this.generalData.jobCandidateRecruiterComment.liveInOwnHouse);
      this.formRecruiterComments.get('hasCar').setValue(this.generalData.jobCandidateRecruiterComment.hasCar);
      this.hasCar = this.generalData.jobCandidateRecruiterComment.hasCar;
      this.formRecruiterComments.get('carDescription').setValue(this.generalData.jobCandidateRecruiterComment.featuresOfTheCar);
      this.formRecruiterComments.get('hasDebt').setValue(this.generalData.jobCandidateRecruiterComment.hasDebt);
      this.hasDebt = this.generalData.jobCandidateRecruiterComment.hasDebt;
      this.formRecruiterComments.get('debitBank').setValue(this.generalData.jobCandidateRecruiterComment.debitBank);
      this.formRecruiterComments.get('debtAmount').setValue(this.generalData.jobCandidateRecruiterComment.debtAmount);
      this.formRecruiterComments.get('monthlyExpense').setValue(this.generalData.jobCandidateRecruiterComment.monthlyExpense);
      this.formRecruiterComments.get('hasValidID').setValue(this.generalData.jobCandidateRecruiterComment.hasValidID);
      this.hasValidID = this.generalData.jobCandidateRecruiterComment.hasValidID;
      this.formRecruiterComments.get('idReason').setValue(this.generalData.jobCandidateRecruiterComment.idReason);
      this.formRecruiterComments.get('hasFamilyWorking').setValue(this.generalData.jobCandidateRecruiterComment.hasFamilyWorking);
      this.hasFamilyWorking = this.generalData.jobCandidateRecruiterComment.hasFamilyWorking;
      this.formRecruiterComments.get('familyName').setValue(this.generalData.jobCandidateRecruiterComment.familyName);
      this.formRecruiterComments.get('familyRelationship').setValue(this.generalData.jobCandidateRecruiterComment.familyRelationship);
      this.formRecruiterComments.get('trademarkWork').setValue(this.generalData.jobCandidateRecruiterComment.trademarkWork);
      this.formRecruiterComments.get('hasInfonavit').setValue(this.generalData.jobCandidateRecruiterComment.hasInfonavit);
      this.hasInfonavit = this.generalData.jobCandidateRecruiterComment.hasInfonavit;
      this.formRecruiterComments.get('monthlyDiscount').setValue(this.generalData.jobCandidateRecruiterComment.monthlyDiscount);
      this.formRecruiterComments.get('hasTattoo').setValue(this.generalData.jobCandidateRecruiterComment.hasTattoo);
      this.hasTattoo = this.generalData.jobCandidateRecruiterComment.hasTattoo;
      this.formRecruiterComments.get('tattooComments').setValue(this.generalData.jobCandidateRecruiterComment.tattooComments);
      this.formRecruiterComments.get('hasPiercing').setValue(this.generalData.jobCandidateRecruiterComment.hasPiercing);
      this.hasPiercing = this.generalData.jobCandidateRecruiterComment.hasPiercing;
      this.formRecruiterComments.get('piercingComments').setValue(this.generalData.jobCandidateRecruiterComment.piercingComments);
      this.formRecruiterComments.get('hasDisease').setValue(this.generalData.jobCandidateRecruiterComment.chronicConditions);
      this.hasDisease = this.generalData.jobCandidateRecruiterComment.chronicConditions;
      this.formRecruiterComments.get('diseaseComments').setValue(this.generalData.jobCandidateRecruiterComment.chronicConditionsComment);
      this.formRecruiterComments.get('hasSurgery').setValue(this.generalData.jobCandidateRecruiterComment.hasSurgery);
      this.hasSurgery = this.generalData.jobCandidateRecruiterComment.hasSurgery;
      this.formRecruiterComments.get('alimony').setValue(this.generalData.jobCandidateRecruiterComment.alimony);
      this.formRecruiterComments.get('positionType').setValue(this.generalData.jobCandidateRecruiterComment.positionType);
      this.formRecruiterComments.get('surgeryComments').setValue(this.generalData.jobCandidateRecruiterComment.surgeryComments);
      this.formRecruiterComments.get('trackingStatus').setValue(this.generalData.jobCandidateRecruiterComment.trackingStatusId.toString());
      this.formRecruiterComments.get('additionalComments').setValue(this.generalData.jobCandidateRecruiterComment.additionalComments);
      this.formRecruiterComments.get('responsablePositionId').setValue(this.generalData.jobCandidateRecruiterComment.responsablePositionId.toString());
      this.formRecruiterComments.get('responsableName').setValue(this.generalData.jobCandidateRecruiterComment.responsableName);
      this.formRecruiterComments.get('availabilityTravel').setValue(this.generalData.jobCandidateRecruiterComment.availabilityTravel);
      this.formRecruiterComments
        .get('trademark').setValue(this.patchTrademarks(this.generalData.jobCandidateRecruiterComment.jobCandidateTrademarkItem));
      this.formRecruiterComments
        .get('skill').setValue(this.patchSkills(this.generalData.jobCandidateRecruiterComment.jobCandidateSkillItem));
      this.formRecruiterComments.get('trademarkId').setValue(this.generalData.jobCandidateRecruiterComment.trademarkId);
      let dtoTrademark = { id: this.generalData.jobCandidateRecruiterComment.trademarkId } as IDtoCatalog
      this.getCatalogRequisitions(dtoTrademark);
    }
  }
  private mapStudy(form: any): IStudy {
    const data = {} as IStudy;
    data.institute = form.institute;
    data.periodFrom = form.periodFrom;
    data.periodTo = form.periodTo;
    data.documentReceivedId = form.documentReceived;
    data.educationLevelId = form.levelEducation;
    data.schoolLevelId = form.schoolLevel;
    data.jobCandidateId = this.generalData.id;
    if (this.generalData.jobCandidateLevelEducation !== null) {
      data.id = this.generalData.jobCandidateLevelEducation.id === undefined ? 0 : this.generalData.jobCandidateLevelEducation.id;
    }
    return data;
  }
  private mapEmploymentHistory(form: any): IEmploymentHistory {
    const data = {} as IEmploymentHistory;
    data.monthlySalaryDesired = form.monthlySalary;
    data.availabilityId = form.availability;
    data.hasExperience = form.hasExperience;
    data.comments = form.comments;
    data.isActive = true;
    data.isVisible = true;
    data.jobCandidateId = this.generalData.id;
    if (this.generalData.jobCandidateEmploymentHistory !== null) {
      data.id = this.generalData.jobCandidateEmploymentHistory.id === undefined ? 0 : this.generalData.jobCandidateEmploymentHistory.id;
    }
    data.jobCandidateEmploymentHistoryItem = this.workHistories;
    return data;
  }
  private mapRecruiterComments(form: any): IRecruiterComment {
    const data = {} as IRecruiterComment;
    data.positionId = form.positionNOM;
    data.liveInOwnHouse = form.hasHouse;
    data.hasCar = form.hasCar;
    data.featuresOfTheCar = form.carDescription === null ? '' : form.carDescription;
    data.hasDebt = form.hasDebt;
    data.debitBank = form.debitBank;
    data.debtAmount = form.debtAmount;
    data.monthlyExpense = form.monthlyExpense;
    data.hasValidID = form.hasValidID;
    data.idReason = form.idReason;
    data.hasFamilyWorking = form.hasFamilyWorking;
    data.familyName = form.familyName;
    data.familyRelationship = form.familyRelationship;
    data.trademarkWork = form.trademarkWork === null ? '' : form.trademarkWork;
    data.hasInfonavit = form.hasInfonavit;
    data.monthlyDiscount = form.monthlyDiscount === null ? 0 : form.monthlyDiscount;
    data.hasTattoo = form.hasTattoo;
    data.tattooComments = form.tattooComments;
    data.hasPiercing = form.hasPiercing;
    data.piercingComments = form.piercingComments;
    data.chronicConditions = form.hasDisease;
    data.chronicConditionsComment = form.diseaseComments;
    data.hasSurgery = form.hasSurgery;
    data.alimony = form.alimony;
    data.positionType = form.positionType;
    data.surgeryComments = form.surgeryComments;
    data.trackingStatusId = form.trackingStatus == undefined ? 1 : form.trackingStatus;
    data.additionalComments = form.additionalComments;
    data.responsablePositionId = form.responsablePositionId;
    data.responsableName = form.responsableName;
    data.availabilityTravel = form.availabilityTravel;
    data.jobCandidateSkillItem = this.setSkills(form.skill);
    data.jobCandidateTrademarkItem = this.setTrademarks(form.trademark);
    data.jobCandidateId = this.generalData.id;
    if (this.generalData.jobCandidateRecruiterComment !== null) {
      data.id = this.generalData.jobCandidateRecruiterComment.id === undefined ? 0 : this.generalData.jobCandidateRecruiterComment.id;
    }
    data.trademarkId = form.trademarkId;
    return data;
  }
  private setSkills(skills: any): ISkillItem[] {
    const data = [];
    skills.forEach((element: any) => {
      const obj = {} as ISkillItem;
      obj.skillId = Number(element);
      obj.jobCandidateRecruiterCommentId = this.generalData.jobCandidateRecruiterComment === null ? 0
        : this.generalData.jobCandidateRecruiterComment.id
      data.push(obj);
    });
    return data;
  }
  private patchSkills(skills: ISkillItem[]): string[] {
    const data = [];
    if (skills != null) {
      skills.forEach(element => {
        data.push(element.skillId.toString());
      });
    }
    return data;
  }
  private setTrademarks(trademarks: ITrademarkItem[]): ITrademarkItem[] {
    const data = [];
    trademarks.forEach(element => {
      const obj = {} as ITrademarkItem;
      obj.trademarkId = Number(element);
      obj.jobCandidateRecruiterCommentId = this.generalData.jobCandidateRecruiterComment === null ? 0
        : this.generalData.jobCandidateRecruiterComment.id
      data.push(obj);
    });
    return data;
  }
  private patchTrademarks(trademarks: ITrademarkItem[]): string[] {
    const data = [];
    if (trademarks != null) {
      trademarks.forEach(element => {
        data.push(element.trademarkId);
      });
    }
    return data;
  }
  private getRfc(): void {
    const firstName = this.formGeneralData.get('firstName');
    const lastName = this.formGeneralData.get('lastName');
    const secondLastName = this.formGeneralData.get('secondLastName');
    const birthDate = this.formGeneralData.get('birthDate');

    if (firstName.errors !== null
      || birthDate.errors !== null) {
      this.configGeneral.newToast('Validación', 'Nombres, apellidos, fecha de nacimiento requeridos para consultar su RFC', 'warning');
      firstName.markAsTouched({ onlySelf: true });
      secondLastName.markAsTouched({ onlySelf: true });
      birthDate.markAsTouched({ onlySelf: true });
      return;
    }
    const date = `${(birthDate.value.getMonth() + 1)}/${birthDate.value.getDate()}/${birthDate.value.getFullYear()}`;
    this.recruitmentService.getRfc(firstName.value, lastName.value, secondLastName.value, date).subscribe((res) => {
      this.formGeneralData.get('rfc').setValue(res);
    });
  }
  private getCurp(): void {
    const firstName = this.formGeneralData.get('firstName');
    const lastName = this.formGeneralData.get('lastName');
    const secondLastName = this.formGeneralData.get('secondLastName');
    const gender = this.formGeneralData.get('gender');
    const birthDate = this.formGeneralData.get('birthDate');
    const stateBirth = this.formGeneralData.get('stateBirth');

    if (firstName.errors !== null
      || lastName.errors !== null
      || secondLastName.errors !== null
      || gender.errors !== null
      || birthDate.errors !== null
      || stateBirth.errors !== null) {
      this.configGeneral.newToast('Validación', 'Nombres, apellidos, fecha nacimiento, sexo, estado donde nació requeridos para consultar su CURP', 'warning');
      firstName.markAsTouched({ onlySelf: true });
      lastName.markAsTouched({ onlySelf: true });
      secondLastName.markAsTouched({ onlySelf: true });
      gender.markAsTouched({ onlySelf: true });
      birthDate.markAsTouched({ onlySelf: true });
      stateBirth.markAsTouched({ onlySelf: true });
      return;
    }
    const date = `${(birthDate.value.getMonth() + 1)}/${birthDate.value.getDate()}/${birthDate.value.getFullYear()}`;
    this.recruitmentService.getCurp(firstName.value
      , lastName.value
      , secondLastName.value
      , gender.value
      , date
      , stateBirth.value).subscribe((res) => {
        this.formGeneralData.get('curp').setValue(res);
      });
  }
  private getCatalogStates(): void {
    this.recruitmentService.getCatalogStates().subscribe((res) => {
      this.catalogStates = res;
    });
  }
  private getCatalogCountries(): void {
    this.recruitmentService.getCatalogCountries().subscribe((res) => {
      this.catalogCountries = res;
    });
  }
  private getCatalogZones(): void {
    this.recruitmentService.getCatalogZones().subscribe((res) => {
      this.catalogZones = res;
    });
  }
  private getCatalogMaritalStatus(): void {
    this.recruitmentService.getCatalogMaritalStatus().subscribe((res) => {
      this.catalogMaritalStatus = res;
    });
  }
  private getCatalogSources(): void {
    this.recruitmentService.getCatalogSources().subscribe((res) => {
      this.catalogSources = res;
    });
  }
  private getCatalogSizes(): void {
    this.recruitmentService.getCatalogSizes().subscribe((res) => {
      this.catalogSizes = res;
    });
  }
  private getCatalogPhysicalComplexions(): void {
    this.recruitmentService.getCatalogPhysicalComplexions().subscribe((res) => {
      this.catalogPhysicalComplexion = res;
    });
  }
  private getCatalogShirtSizes(): void {
    this.recruitmentService.getCatalogShirtSizes().subscribe((res) => {
      this.catalogShirtSizes = res;
    });
  }
  private getCatalogPhoneCompanies(): void {
    this.catalogPhoneCompanies = this.recruitmentService.getCatalogPhoneCompanies();
  }
  private getCatalogPhonePlans(): void {
    this.catalogPhonePlans = this.recruitmentService.getCatalogPhonePlans();
  }
  private getCatalogSchoolLevels(): void {
    this.recruitmentService.getCatalogSchoolLevels().subscribe((res) => {
      this.catalogSchoolLevels = res;
    });
  }
  private getCatalogStatures(): void {
    this.recruitmentService.getCatalogStatures().subscribe((res) => {
      this.catalogStatures = res;
    });
  }
  private getCatalogShoeSizes(): void {
    this.recruitmentService.getCatalogShoeSizes().subscribe((res) => {
      this.catalogShoeSizes = res;
    });
  }
  private getCatalogPositions(): void {
    this.recruitmentService.getCatalogPositions().subscribe((res) => {
      this.catalogPositions = res;
    });
  }
  private getCatalogEducationLevels(): void {
    this.recruitmentService.getCatalogEducationLevels().subscribe((res) => {
      this.catalogEducationLevels = res;
    });
  }
  private getCatalogDocumentsReceived(): void {
    this.recruitmentService.getCatalogDocumentsReceived().subscribe((res) => {
      this.catalogDocumentsReceived = res;
    });
  }
  private getCatalogAvailabilitys(): void {
    this.recruitmentService.getCatalogAvailabilitys().subscribe((res) => {
      this.catalogAvailabilitys = res;
    });
  }
  private getCatalogReasonsOfExit(): void {
    this.recruitmentService.getCatalogReasonsOfExit().subscribe((res) => {
      this.catalogReasonsOfExit = res;
    });
  }
  private getCatalogSkills(): void {
    this.recruitmentService.getCatalogSkills().subscribe((res) => {
      this.catalogSkills = res;
    });
  }
  private getCatalogTrackingStatus(): void {
    this.recruitmentService.getCatalogTrackingStatus().subscribe((res) => {
      this.catalogTrackingStatus = res;
    });
  }
  private getCatalogRecruiters(): void {
    this.recruitmentService.getCatalogRecruiters().subscribe((res) => {
      this.catalogRecruiters = res;
    });
  }
  // private getCatalogRequisitions(): void {
  //   this.openingService.getCatalogRequisitions().subscribe((res) => {
  //     this.catalogRequisitions = res.data as ISelect[];
  //   });
  // }
  private getCatalogTowns(id: string): void {
    this.recruitmentService.getCatalogTowns(id).subscribe((res) => {
      this.formGeneralData.get('town').setValue(null);
      this.catalogTowns = res;
      if (this.action === 'update') {
        this.formGeneralData.get('town').setValue(this.generalData.townId.toString());
      }
    });
  }
  private getCatalogStateBirth(id: string): void {
    this.recruitmentService.getCatalogStateBirth(id).subscribe((res) => {
      this.formGeneralData.get('stateBirth').setValue(null);
      this.catalogStateBirth = res;
      if (this.action === 'update') {
        this.formGeneralData.get('stateBirth').setValue(this.generalData.stateBirthId.toString());
      }
    });
  }
  private changeMaritalStatus(dto: ISelect): void {
    if (dto == undefined) {
      this.formGeneralData.get('patrimonialRegimeId').setValidators(null);
      this.formGeneralData.get('patrimonialRegimeId').setValue(null);
      return;
    }
    if (dto.text != 'CASADO') {
      this.formGeneralData.get('patrimonialRegimeId').setValidators(null);
      this.formGeneralData.get('patrimonialRegimeId').setValue(null);
    } else {
      this.formGeneralData.get('patrimonialRegimeId').setValidators([Validators.required]);
    }
    this.formGeneralData.get('patrimonialRegimeId').updateValueAndValidity();
  }
  private statusNotAllowed(item: ISelect): void {
    if (item == null) {
      return;
    }
    let status = this.catalogTrackingStatus.filter(x => x.id == item.id)[0];
    if (status.id == '13') {
      this.configGeneral.newToast('Estatus', `Estatus ${status.text} no disponible`, 'warning');

      this.formRecruiterComments.get('trackingStatus').setValue(null);
    }
  }
  private getCatalogRequisitions(dto: IDtoCatalog): void {
    this.catalogRequisitions = null;
    this.formRecruiterComments.get('positionNOM').setValue(null);
    if (dto === undefined) {
      return;
    }
    this.openingService.getCatalogRequisitionsByTrademarkId(dto.id).subscribe((res) => {
      this.catalogRequisitions = res.data as ISelect[];
      if (this.catalogRequisitions.length > 0 && this.action === 'update') {
        this.formRecruiterComments.get('positionNOM').setValue(this.generalData.jobCandidateRecruiterComment.positionId.toString());
      }
    });
  }
  validarNombre(event: any) {
    let regex = /^[A-Za-z. ]*$/;
  let value = event.target.value;

  if (!regex.test(value)) {
    this.formGeneralData.get('firstName')!.setValue(value.slice(0, -1));
  }

  // Convertir el valor a mayúsculas
  this.formGeneralData.get('firstName')!.setValue(value.toUpperCase());
  }
}
